import permissions from "app/permissions";
import EditCyclicExamExceptions from "./Edit";
import { CYCLIC_EXAM_EXCEPTIONS, StudentServicePath } from "utils/constants";

export const resources = {
  name: StudentServicePath + CYCLIC_EXAM_EXCEPTIONS + "/:id",
  title: "Циклични изпити",
  custom: <EditCyclicExamExceptions />,
  permission: permissions.canPreviewCurriculums,
};
